import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { PaginationService } from 'src/app/PaginationService';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';

@Component({
  selector: 'app-feedback-template-detail',
  templateUrl: './feedback-template-detail.component.html',
  styleUrls: ['./feedback-template-detail.component.scss']
})
export class FeedbackTemplateDetailComponent implements OnInit {

  feedbackTemplateData: any = {};
  openSnackbar: any;
  errorStatus: any;
  isProcessing = false;

  isAdenabled: boolean = false;
  constructor(public appService: AppService, public router: Router, private readonly snackBar: MatSnackBar, private readonly authService: MsalService,
    public paginationService: PaginationService, public message: messageService, public dialog: MatDialog, private readonly elem: ElementRef) {
    const data: any = router.getCurrentNavigation()?.extras.state;
    this.feedbackTemplateData = data['feedbackTemplateData'];
    this.feedbackTemplateData.isActive1 = this.feedbackTemplateData.isActive == "Y";
    this.getCallMethod();
  }

  visibleInfoPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('infoPopup', { static: true }) infoPopup: TemplateRef<any>;

  visibleReorderQuestionPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('reorderQuestionPopup', { static: true }) reorderQuestionPopup: TemplateRef<any>;

  infoPopupConfig = {
    width: '500px',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  reorderQuestionPopupConfig = {
    width: '700px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  uiDateFormat: any = 'dd-MMM-yyyy';
  uiDateTimeFormat: any = 'dd-MMM-yyyy HH:mm:ss'
  dropDownDataForFieldType: any = [];
  ngOnInit() {
    this.isAdenabled = localStorage.getItem("adEnabled") == 'Y';
    let obj = JSON.parse(sessionStorage.getItem('getUserTimezoneDetails') || '{}');
    if (obj.uiDateFormat != undefined && obj.uiDateFormat != null) {
      this.uiDateFormat = obj.uiDateFormat.replace("DD", 'dd').replace("MON", "MMM").replace("YYYY", "yyyy");

    }
    if (obj.uiDateIMEFormat != undefined && obj.uiDateIMEFormat != null) {
      this.uiDateTimeFormat = obj.uiDateIMEFormat.replace("DD", 'dd').replace("HH24:MI:SS", 'HH:mm:ss').replace("MON", "MMM").replace("YYYY", "yyyy");
    }
    this.columnList = [{ column: "Seq", width: "100px" }, { column: "Question Code", width: "200px" }, { column: "Question", width: "240px" }, { column: "Field Type", width: "200px" },
    { column: "LOV Values", width: "200px" }, { column: "Value Scores", width: "140px" }, { column: "Created On", width: "180px" },
    { column: "Created By", width: "200px" }, { column: "Updated On", width: "180px" }, { column: "Updated By", width: "200px" }, { column: "Update Raeson", width: "200px" }]

    this.isProcessing = true;
    this.appService.getCodeListsByGroup("FIELD_TYPE").subscribe((data: any) => {
      this.dropDownDataForFieldType = [];
      const allowedTypes = new Set([
        "Text Field",
        "Large Text Field",
        "Drop Down",
        "Radio Button"
      ]);

      for (const item of data) {
        if (allowedTypes.has(item.codelistCode)) {
          this.dropDownDataForFieldType.push(item);
        }
      }
      this.feedbackTemplateData.updateReason = '';
      this.selectBoxForFieldType();
      this.isProcessing = false;
    })
  }

  fieldTypeListDropdown: any = [];
  fieldTypesearchTxt: any;
  selectBoxForFieldType() {
    this.fieldTypeListDropdown = [];

    for (const fieldType of this.dropDownDataForFieldType) {
      this.fieldTypeListDropdown = this.fieldTypeListDropdown.concat({
        valueExp: fieldType.codelistCode,
        displayExp: fieldType.codelistName
      });
    }
  }
  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }

      index1++;
    })


    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnList.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }

    })
  }

  backToFormTemplate() {
    this.message.breadcrumbData.thirdLevel = "Feedback";
    history.back();
  }

  templateName: any;
  templateNameRequiredMsg: any;
  updateReq: any;
  updateReqMsg: any;
  updateRequired: any;
  updateRequiredMsg: any;
  fieldValidation() {
    this.templateName = document.getElementById('templateName') as HTMLInputElement;
    this.templateNameRequiredMsg = document.getElementById('templateName-required-msg') as HTMLInputElement;
    this.updateReq = document.getElementById('update') as HTMLInputElement;
    this.updateReqMsg = document.getElementById('update-required-msg') as HTMLInputElement;

    if (this.feedbackTemplateData.templateName == "" || this.feedbackTemplateData.templateName == null) {
      this.templateName.style.border = '1px solid red';
      this.templateNameRequiredMsg.style.display = 'block';
    } else {
      this.templateName.style.border = 'none';
      this.templateNameRequiredMsg.style.display = 'none';
    }
    if (this.feedbackTemplateData.updateReason) {
      this.updateReq.style.border = 'none';
      this.updateReqMsg.style.display = 'none';
    } else {
      this.updateReq.style.border = '1px solid red';
      this.updateReqMsg.style.display = 'block';
    }

  }


  updateFeedbackTemplate() {
    this.isProcessing = true;
    if (this.feedbackTemplateData.templateName == "" || this.feedbackTemplateData.templateName == null || !this.feedbackTemplateData.updateReason) {
      this.fieldValidation();
      this.isProcessing = false;
    } else {
      this.fieldValidation();
      delete this.feedbackTemplateData.updatedOn;
      if (this.feedbackTemplateData.createdOn != null) {
        this.feedbackTemplateData.createdOn = new Date(this.feedbackTemplateData.createdOn);
      }

    
      this.feedbackTemplateData.isActive = this.feedbackTemplateData.isActive1 ? "Y" : "N";

      this.appService.updateFeedbackTemplate(this.feedbackTemplateData).subscribe({
        next: (Response: any) => {
          this.isProcessing = false;
           if (Response.resultType == 'S') {
            this.feedbackTemplateData.updateReason = '';
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",
              pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });

    }
  }


  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  feedbackTemplateQuestionList: any = [];
  feedbackTemplateQuestionData: any = {};
  searchValue: string = '';
  operationFlag: any;
  title = "";

  showingRowsText = "Showing rows";
  perPage = 10;
  maxSize = 3;
  collectionSize: number;

  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  displayMessage: any;

  visibleAddButton: boolean = false;
  visibleEditButton: boolean = false;



  columnList: any;
  visibleAddOrEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('addOrEditPopup', { static: true }) addOrEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;


  addOrEditPopupConfig = {
    width: '900px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  deletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  getCallMethod() {
    this.appService.getFeedbackTemplateQuestionList(
      this.feedbackTemplateData.templateId).subscribe((data: any) => {
        this.isProcessing = false;
        this.feedbackTemplateQuestionList = data;
        this.collectionSize = this.feedbackTemplateQuestionList.length;

        this.setPage(1, 0);
        this.pager.totalPages = undefined;
      })
  }

  pager: any = {};
  pagedItems: any[];
  makeStickyColumns: any;

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.feedbackTemplateQuestionList.length, page, this.perPage, targetpage);
    this.pagedItems = this.feedbackTemplateQuestionList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  feedbackTemplateQuestionListTemp: any = [];
  setPagedorserch(page: number, targetpage: number) {

    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.feedbackTemplateQuestionListTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.feedbackTemplateQuestionListTemp.length, page, this.perPage, targetpage);
      this.pagedItems = this.feedbackTemplateQuestionListTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.feedbackTemplateQuestionListTemp = this.feedbackTemplateQuestionList;
      this.pager = this.paginationService.getPager(this.feedbackTemplateQuestionListTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.feedbackTemplateQuestionListTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {

      if (this.feedbackTemplateQuestionList == undefined) {
        return this.feedbackTemplateQuestionList;
      }
      if (!this.feedbackTemplateQuestionList.length) {
        return this.feedbackTemplateQuestionList;
      }
      if (filter) {
        this.feedbackTemplateQuestionListTemp = this.feedbackTemplateQuestionList.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });


      } else {
        this.feedbackTemplateQuestionListTemp = this.feedbackTemplateQuestionList.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });

      }
      this.setPagedorserch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.feedbackTemplateQuestionList.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }
  dataGridParentCheckBoxChecked(e: any) {
    const isChecked = e.target.checked;

    this.childCheckBoxs = isChecked;

    for (const question of this.feedbackTemplateQuestionList) {
      question.childCheckBoxs = isChecked;
    }
  }
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
  }

  refreshGridData() {
    this.getCallMethod();
  }

  openAddPopup() {
    this.feedbackTemplateQuestionData = {};
    this.feedbackTemplateQuestionData.questionCode = "";
    this.feedbackTemplateQuestionData.question = "";
    this.feedbackTemplateQuestionData.fieldTypeCode = "";
    this.feedbackTemplateQuestionData.fieldLovValues = "";
    this.feedbackTemplateQuestionData.fieldValueScores = "";
    this.operationFlag = "ADD";
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.title = "Add Feedback Template Question";
    this.visibleAddOrEditPopup = this.dialog.open(this.addOrEditPopup, this.addOrEditPopupConfig);
  }

  previousData: any = {};
  openEditPopup(editRowData: any) {
    this.isProcessing = true;
    this.previousData = editRowData;
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.operationFlag = 'EDIT';
    this.title = "Update Feedback Template Question"
    this.appService.getFeedbackTemplateQuestionById(editRowData.templateId,
      editRowData.questionId).subscribe((response: any) => {
        this.feedbackTemplateQuestionData = response[0];
        this.feedbackTemplateQuestionData.updateReason = '';
        this.isProcessing = false;
      })
    this.visibleAddOrEditPopup = this.dialog.open(this.addOrEditPopup, this.addOrEditPopupConfig);
  }
  cancelAddAndEditFunction() {
    this.visibleAddOrEditPopup.close();
  }


  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filter === '') {
      this.pagedItems = this.feedbackTemplateQuestionList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.feedbackTemplateQuestionList.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)

      );
    }
  }

  questionCodeCss: any;
  questionCodeReqdMsg: any;

  questionCss: any;
  questionReqdMsg: any;

  fieldTypeCss: any;
  fieldTypeReqdMsg: any;
  fieldValidationForQuestion() {
    this.questionCodeCss = document.getElementById('questionCode') as HTMLInputElement;
    this.questionCodeReqdMsg = document.getElementById('questionCode-required-msg') as HTMLInputElement;

    this.questionCss = document.getElementById('question') as HTMLInputElement;
    this.questionReqdMsg = document.getElementById('question-required-msg') as HTMLInputElement;

    this.fieldTypeCss = document.getElementById('fieldType') as HTMLInputElement;
    this.fieldTypeReqdMsg = document.getElementById('fieldType-required-msg') as HTMLInputElement;

    this.updateRequired = document.getElementById('update-req') as HTMLInputElement;
    this.updateRequiredMsg = document.getElementById('update-req-msg') as HTMLInputElement;

    if (this.feedbackTemplateQuestionData.questionCode == "") {
      this.questionCodeCss.style.border = '1px solid red';
      this.questionCodeReqdMsg.style.display = 'block';
    } else {
      this.questionCodeCss.style.border = 'none';
      this.questionCodeReqdMsg.style.display = 'none';
    }

    if (this.feedbackTemplateQuestionData.question == "") {
      this.questionCss.style.border = '1px solid red';
      this.questionReqdMsg.style.display = 'block';
    } else {
      this.questionCss.style.border = 'none';
      this.questionReqdMsg.style.display = 'none';
    }

    if (this.feedbackTemplateQuestionData.fieldTypeCode == "") {
      this.fieldTypeCss.style.border = '1px solid red';
      this.fieldTypeReqdMsg.style.display = 'block';
    } else {
      this.fieldTypeCss.style.border = 'none';
      this.fieldTypeReqdMsg.style.display = 'none';
    }

    if (this.visibleEditButton) {
      if (this.feedbackTemplateQuestionData.updateReason) {
        this.updateRequired.style.border = 'none';
        this.updateRequiredMsg.style.display = 'none';
      } else {
        this.updateRequired.style.border = '1px solid red';
        this.updateRequiredMsg.style.display = 'block';
      }
    }
  }
  focusEmpty() {
    console.log();
  }

  addAndEditFunction(feedbackQuestionData: any) {
    this.isProcessing = true;
    if (feedbackQuestionData.questionCode == "" || feedbackQuestionData.question == "" || feedbackQuestionData.fieldTypeCode == "" || (this.visibleEditButton && !feedbackQuestionData.updateReason)) {
      this.fieldValidationForQuestion();
      this.isProcessing = false;
    } else {
      if (this.operationFlag == "ADD") {

        this.feedbackTemplateQuestionData.templateId = this.feedbackTemplateData.templateId;
        this.appService.createFeedbackTemplateQuestion(this.feedbackTemplateQuestionData).subscribe({
          next: (data: any) => {
            this.isProcessing = false;
            if (data.resultType == "S") {
              this.visibleAddOrEditPopup.close();
              this.getCallMethod();
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: data.result,
                type: data.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: data.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }, error: (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          }
        });
      } else {

        delete this.feedbackTemplateQuestionData['createdOn'];
        delete this.feedbackTemplateQuestionData['updatedOn'];
        this.appService.updateFeedbackTemplateQuestion(this.feedbackTemplateQuestionData).subscribe({
          next: (data: any) => {
            this.isProcessing = false;
            if (data.resultType == "S") {
              this.visibleAddOrEditPopup.close();
              this.getCallMethod();
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: data.result,
                type: data.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: data.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }, error: (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          }
        });
      }
    }



  }


  openDeletePopup(feedback: any) {
    this.feedbackTemplateQuestionData = feedback;
    this.title = "Delete Feedback Template Question";
    if (this.feedbackTemplateQuestionData.deleteReason != undefined) {
      this.feedbackTemplateQuestionData.deleteReason = '';
    }
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }
  deleteFiledValueRequiredMsg: any;
  deleteValidation() {
    this.deleteFiledValueRequiredMsg = document.getElementById('deleteTextarea-required-msg') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.isProcessing = false;
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }
  deleteFiledValue: any;
  deleteFunction() {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteValidation();
      this.isProcessing = false;
    } else {

      delete this.feedbackTemplateQuestionData['createdOn'];
      delete this.feedbackTemplateQuestionData['updatedOn'];
      this.appService.deleteFeedbackTemplateQuestion(this.feedbackTemplateQuestionData).subscribe({
        next: (data: any) => {
          this.isProcessing = false;
          this.visibleDeletePopup.close();
          this.isProcessing = true;
          this.getCallMethod();
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }

  }

  callReorderFunc() {
    this.title = "Reorder Question";
    for (let i = 0; i < this.feedbackTemplateQuestionList.length; i++) {
      this.feedbackTemplateQuestionList[i].newSeq = i + 1;
    }
    this.visibleReorderQuestionPopup = this.dialog.open(this.reorderQuestionPopup, this.reorderQuestionPopupConfig);
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.feedbackTemplateQuestionList, event.previousIndex, event.currentIndex);
    for (let i = 0; i < this.feedbackTemplateQuestionList.length; i++) {
      this.feedbackTemplateQuestionList[i].newSeq = i + 1;
    }
  }

  reorderQuestionFunction() {
    this.isProcessing = true;
    for (let i = 0; i < this.feedbackTemplateQuestionList.length; i++) {
      delete this.feedbackTemplateQuestionList[i].createdOn;
      delete this.feedbackTemplateQuestionList[i].updatedOn;
      this.feedbackTemplateQuestionList[i].questionSeq = this.feedbackTemplateQuestionList[i]['newSeq'];

      this.appService.updateFeedbackTemplateQuestion(this.feedbackTemplateQuestionList[i]).subscribe((data: any) => {
        if (i == this.feedbackTemplateQuestionList.length - 1) {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.visibleReorderQuestionPopup.close();
            this.getCallMethod();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              // Changed this line to show the custom success message
              message: data.resultType == 'S' ? 'reorder sequence updated successfully' : data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }
      })
    }
  }

  cancelReorderFunction() {
    this.visibleReorderQuestionPopup.close();
  }

}
